export default function LoadingSpinner({ fullPage = false }) {
  const spinner = (
    <div className="d-flex align-items-center gap-2" style={{ color: 'var(--cjc-primary)' }}>
      <div className="spinner-border spinner-border-sm" role="status" aria-hidden="true" />
      <span>Carregando...</span>
    </div>
  );

  if (!fullPage) return spinner;

  return (
    <div className="d-flex align-items-center justify-content-center" style={{ minHeight: '100vh' }}>
      {spinner}
    </div>
  );
}
